import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { LoginMode } from '../../redux/Actions/Security/ActionTypes';
import { IRootState } from '../../redux/Reducers/RootReducer';
import Content from './layout/Content/Content';
import Header from './layout/Header/Header';
import './Search.css';

/* import SideNav from './layout/SideNav/SideNav'; */

function mapStateToProps(state: IRootState, ownProps: any) {
  return { username: state.securityState.security.username, loginMode: state.securityState.security.loginMode };
}

class Search extends React.Component<any, any> {
  public render() {
    const isEmbeddedLogin = !!(this.props.loginMode && this.props.loginMode === LoginMode.EMBEDDED);

    return (
      <div className="Search">
        {!isEmbeddedLogin ? (
          <div className="header">
            <Header />
          </div>
        ) : (
          <></>
        )}
        <div className="body">
          <div className="center">
            <Content />
          </div>
          {/*  <div className="sidebar">
            <SideNav />
          </div> */}
        </div>
        {!isEmbeddedLogin ? (
          <div className="footer">
            <BreadCrumbs />
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  null
)(Search) as any);
